<template>
  <p id="back-top" :class="{show:isActive}">
    <a href="javascript:;" @click="toTop(step)">
      <img style='width: 100%;' src="../assets/scroll-top.png" alt=""></a>
    <!--<a href="#top"><i class="fa fa-play"></i></a>-->
  </p>
</template>
<style  scoped>
  #back-top.show{
    display: block;
  }
  #back-top{
    position: fixed;
    z-index: 999999;
    bottom: 35px;
    right: 35px;
    display: none;
  }
  #back-top a {
    width: 40px;
    height: 40px;
    display: block;
    text-align: center;
    font: 11px/100% Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    text-decoration: none;
    color: #FFFFFF;
    /* background: #A9A9B1; */
    background: #8a8a8a;
    opacity: 0.8;
    -moz-border-radius: 30px;
    -webkit-border-radius: 30px;
    border-radius: 30px;
    -webkit-transition: 1s;
    -moz-transition: 1s;
    transition: 1s;
    padding: 10px;
    box-sizing: border-box;
  }
    @media (max-width: 650px) {
      #back-top{
        right: 15px;
      }
    }
</style>
<script>
  export default {
    name: "ScrollTar",
    data() {
      return {
        isActive:false,
      };
    },
    mounted (){

    },
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    created(){
      window.onscroll=()=>{
        if (document.documentElement.scrollTop>60) {
          this.isActive=true;
        }else {
          this.isActive=false;
        }
      }
    },
    methods: {
      toTop(i){
        //参数i表示间隔的幅度大小，以此来控制速度
        document.documentElement.scrollTop-=i;
        if (document.documentElement.scrollTop>0) {
          var c=setTimeout(()=>this.toTop(i),0);
        }else {
          clearTimeout(c);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ScrollTop.vue